(function () {
  console.log('custom-bundle-product.js');

  const setAriaExpanded = (id, value) => {
    if (!id) return;
    const triggers = document.querySelectorAll('.product-bundle-drawer__trigger[aria-controls="' + id + '"]');
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', value));
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.product-bundle-drawer__trigger');
    if (trigger) {
      event.preventDefault();
      const targetId = trigger.getAttribute('aria-controls');
      if (!targetId) return;

      trigger.classList.add('is--loading');

      const drawer = document.getElementById(targetId);
      if (drawer) {
        drawer.classList.add('is-open');
        setAriaExpanded(targetId, 'true');
        trigger.classList.remove('is--loading');
      }
      return;
    }

    const closeButton = event.target.closest('.product-bundle-drawer__close');
    if (closeButton) {
      const drawer = closeButton.closest('.product-bundle-drawer');
      if (!drawer) return;

      drawer.classList.remove('is-open');
      const controlledId = drawer.getAttribute('id');
      setAriaExpanded(controlledId, 'false');
      return;
    }

    const overlay = event.target.closest('.product-bundle-drawer__overlay');
    if (overlay) {
      const drawer = overlay.closest('.product-bundle-drawer');
      if (!drawer) return;

      drawer.classList.remove('is-open');
      const controlledId = drawer.getAttribute('id');
      setAriaExpanded(controlledId, 'false');
    }
  });
})();
